import { Loadable } from '../../components/common/loadable/loadable';

export const TeamLazyLoadContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "team" */ './team.container').then(
      (module) => module.TeamContainer,
    ),
});
